require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window
ns.ReactRailsUJS = require('react_ujs')
